import { AlertTriangle } from "@/components/ui/icons";
import { Text } from "react-native";

import { Button } from "@/components/ui/Button";
import { Screen } from "@/components/ui/Screen";

/**
 * The calm recovery screen the root ErrorBoundary shows when a render throws. A single bad render —
 * a null price, a malformed catalog field — used to blank the whole app; now the dealer gets a
 * "Something went wrong" with a Retry instead of a white screen mid-show.
 */
export function AppErrorScreen({ message, onRetry }: { message?: string; onRetry: () => void; }) {
  return (
    <Screen className="items-center justify-center gap-4 px-8">
      <AlertTriangle size={40} color="#dc2626" />
      <Text className="text-center text-lg font-title text-foreground">Something went wrong</Text>
      {message
        ? (
          <Text className="text-center text-sm font-body text-muted-foreground" numberOfLines={5}>
            {message}
          </Text>
        )
        : null}
      <Button title="Try again" onPress={onRetry} />
    </Screen>
  );
}
